import VueI18n from 'vue-i18n'
import bowser from 'bowser'

import numberDefaultsFactory from './number-defaults'
import dateTimeDefaultsFactory from './date-time-defaults'

var i18nPluginInstance;

export default function(Vue, {currency, timeZone, numberFormats: regionNumberFormats, dateTimeFormats: regionDateTimeFormats}) {

  Vue.use(VueI18n)

  const numberDefaults = numberDefaultsFactory(currency)
  const dateTimeDefaults = dateTimeDefaultsFactory((bowser.msie) ? undefined : timeZone)

  i18nPluginInstance = new VueI18n({

    locale: process.env.VUE_APP_DEFAULT_LOCALE,
    fallbackLocale: process.env.VUE_APP_FALLBACK_LOCALE,

    /**
     * In-line default language translations at build time.
     * The path to these files must be a BUILD TIME constant, otherwise webpack will interpret the
     * require statement as an expression, and the entire `lang` directory will be included in the bundle.
     */
    messages: {
      [process.env.VUE_APP_DEFAULT_LOCALE]: require('./lang/' + process.env.VUE_APP_DEFAULT_LOCALE + '.yml'),
      [process.env.VUE_APP_FALLBACK_LOCALE]: require('./lang/' + process.env.VUE_APP_FALLBACK_LOCALE + '.yml'),
    },

    numberFormats: merge({},
      {
        [process.env.VUE_APP_DEFAULT_LOCALE]: numberDefaults,
        [process.env.VUE_APP_FALLBACK_LOCALE]: numberDefaults,
      },
      regionNumberFormats
    ),

    dateTimeFormats: merge(
      {
        [process.env.VUE_APP_DEFAULT_LOCALE]: dateTimeDefaults,
        [process.env.VUE_APP_FALLBACK_LOCALE]: dateTimeDefaults,
      },
      regionDateTimeFormats
    ),

    silentFallbackWarn: true,
    silentTranslationWarn: false,
  })

  return {
    i18n: i18nPluginInstance,
    changeLanguage,
    i18nHasMessage,
  }
}

function changeLanguage ( language ) {
  
  let html = document.querySelector('html')
  html.setAttribute('lang', language.iso)
  html.setAttribute('dir', language.rightToLeft ? 'rtl' : 'ltr')

  // Load translations for new language
  Promise.all([_loadLanguagePack(language.baseIso), _loadLanguagePack(language.iso)])
    .then(([baseTranslations, regionTranslations]) => {
      let merged = merge({}, baseTranslations, regionTranslations)
      // Add translations into i18n Plugin
      i18nPluginInstance.setLocaleMessage(language.iso, merged)
      i18nPluginInstance.locale = language.iso
    })
}

function _loadLanguagePack (iso) {
  return import(/* webpackChunkName: "i18n-lang-[request]" */ `./lang/${iso}.yml`)
    .then(module => module.default)
}

// Check if the key exists in the current locale's translations or the fallback locale's translations
function i18nHasMessage(key) {
  return i18nPluginInstance.te(key, i18nPluginInstance.locale) || i18nPluginInstance.te(key, i18nPluginInstance.fallbackLocale)
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
function merge(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        merge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return merge(target, ...sources);
}

function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

/*function canUseTimezones () {
  try {
    new Intl.DateTimeFormat('en-US', { year: 'numeric', timeZone: 'Australia/Sydney'}).format(new Date())
    return true
  }
  catch(e) {
    if(e.name == 'RangeError') {
      return false
    }
  }
}*/

/*function removeTimeZones(...items) {
  items.filter(x => x != undefined).forEach(item => {
    Object.entries(item).forEach(([lang, styleSet]) => {
      for(var style in styleSet) {
        delete styleSet[style].timeZone
      }
    })
  })  
}*/